import global from './global';
import has, { add } from 'dojo-shim/support/has';

export * from 'dojo-shim/support/has';
export default has;

add('object-assign', typeof global.Object.assign === 'function');

add('raf', typeof requestAnimationFrame === 'function');

add('arraybuffer', typeof global.ArrayBuffer !== 'undefined');
add('formdata', typeof global.FormData !== 'undefined');
add('xhr', typeof global.XMLHttpRequest !== 'undefined');
add('xhr2', has('xhr') && 'responseType' in global.XMLHttpRequest.prototype);
add('xhr2-blob', function () {
	if (!has('xhr2')) {
		return false;
	}

	const request = new XMLHttpRequest();
	request.open('GET', '/', true);
	request.responseType = 'blob';
	request.abort();
	return request.responseType === 'blob';
});
